


<mat-drawer-container [hasBackdrop]="true" style="background-color: #ffffff;">
  <mat-drawer
    #drawer
    mode="over"
    [(opened)]="drawerOpen"
    position="end">
    <div class="row" class="side-drawer">
      <div class="col-md-12">
        <button mat-icon-button
          type="button"
          id="close-drawer-icon"
          (click)="drawer.toggle()"
          aria-label="close drawer" class="float-right small-button">
          <mat-icon>arrow_forward_ios</mat-icon>
        </button>
        <br />
        
        <div  [innerHTML]='drawerContent'></div>
      </div>
    </div>
    <div class="row" style="margin-right: 0; margin-left: 0;">
      <div class="col-md-12">
        <br />
        <button
          type="button"
          id="close-drawer-button"
          mat-raised-button
          (click)="toggleDrawer()">
          CLOSE
        </button>
      </div>
    </div>
</mat-drawer>
<mat-drawer-content>
  <section class="row"   role="main" style="margin-right: 0; margin-left: 0;" >



<div class="row" >
  <div class="col-md-12">
    <div class="row">
      <h1 class="col-md-12">
        Let's get started
      </h1>
      <div class="col-md-12">
        {{addressQuestion}}
      </div>
    </div>
    <form [formGroup]="dwellingInput" (ngSubmit)="toNextSection()" autocomplete="off">
      <div class="row">
        <div class="col-md-6">
          <mat-form-field appearance="outline">
            <mat-label id="address_StreetLabel">Address</mat-label>
            <input
              class="row"
              matInput
              #address_Street
              ebbGoogleAutocomplete
              (whenSelected)="openDropdown($event)"
              (keyup)="onKey($event)"
              (focus)="onFocus($event)"
              id="address_Street"
              formControlName="address_Street"
              autocomplete="street-address"
              aria-label="Street Address"
              aria-labelledby="address_StreetLabel"
              placeholder="Enter Address"
              type="text" data-lpignore="true"
              required trim="blur"
              maxlength="100">
              <mat-error>
                Address is required.
              </mat-error>
              <mat-hint *ngIf="address_Street.value?.length === 100">
                You have reached the maximum number of 100 characters.
              </mat-hint>
              <mat-error
              *ngIf="dwellingInput.get('address_Street').errors && dwellingInput.get('address_Street').errors.validateAddress"
              >
              Invalid address. Please <a href="/contact" target="_blank">contact us</a>
            </mat-error>
          </mat-form-field>
          <div class="pac-wrapper">
            <div #resultDropDown *ngIf="listResults.length" id="resultDropDown" class="pac-container pac-logo">
              <div [class.pac-item-selected]="result.selected" class="pac-item" *ngFor="let result of listResults" (click)="getPlaceDetails(result)">
                <span class="pac-icon pac-icon-marker"></span>
                <span class="pac-item-query">{{result.text}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <mat-form-field appearance="outline">
            <mat-label id="address_StreetLabel2">Address Line 2</mat-label>
            <input
              class="row"
              matInput
              id="address_Street_Line2"
              formControlName="address_Street_Line2"
              placeholder="Enter Address Line 2"
              autocomplete="address-line2"
              aria-label="Address line 2"
              aria-labelledby="address_StreetLabel2"
              type="text" data-lpignore="true"
              trim="blur"
              maxlength="100">
              <mat-hint *ngIf="address_Street.value?.length === 100">
                You have reached the maximum number of 100 characters.
              </mat-hint>
              <mat-error
              *ngIf="dwellingInput.get('address_Street_Line2').errors && dwellingInput.get('address_Street_Line2').errors.pattern"
              >
              Invalid address. Please <a href="/contact" target="_blank">contact us</a>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    
      <div class="row">
        <div class="col-md-6">
          <mat-form-field appearance="outline">
            <mat-label id="address_CityLabel">City</mat-label>
            <input
              matInput
              #address_City
              id="address_City"
              formControlName="address_City"
              placeholder="Enter City"
              autocomplete="address-level2"
              aria-label="City"
              aria-labelledby="address_CityLabel"
              type="text"
              required trim="blur"
              maxlength="100">
              <mat-error>
                City is required.
              </mat-error>
              <mat-hint *ngIf="address_City.value?.length === 100">
                You have reached the maximum number of 100 characters.
              </mat-hint>
              <mat-error
              *ngIf="dwellingInput.get('address_City').errors && dwellingInput.get('address_City').errors.pattern"
              >
              Invalid address. Please <a href="/contact" target="_blank">contact us</a>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <mat-form-field appearance="outline">
            <mat-label id="address_StateLabel">State</mat-label>
            <input
              matInput
              #address_State
              id="address_State"
              formControlName="address_State"
              placeholder="State"
              autocomplete="address-level1"
              aria-label="State"
              aria-labelledby="address_StateLabel"
              type="text" trim="blur"
              readonly>
              <mat-error
              *ngIf="dwellingInput.get('address_State').errors && dwellingInput.get('address_State').errors.pattern"
              >
              Invalid address. Please <a href="/contact" target="_blank">contact us</a>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <mat-form-field appearance="outline">
            <mat-label  id="address_ZipLabel">ZIP Code</mat-label>
            <input
              matInput
              #address_Zip
              id="address_Zip"
              formControlName="address_Zip"
              placeholder="Enter ZIP Code"
              autocomplete="postal-code"
              aria-label="ZIP Code"
              aria-labelledby="address_ZipLabel"
              type="text" trim="blur"
              required
              maxlength="10">
            <mat-error
              *ngIf="dwellingInput.get('address_Zip').errors && dwellingInput.get('address_Zip').errors.required"
              >
              Zip Code is required.
            </mat-error>
            <mat-error
              *ngIf="dwellingInput.get('address_Zip').errors && dwellingInput.get('address_Zip').errors.zipNotIncluded"
              >
              Unfortunately, your ZIP Code is NOT in the current EBB Program. Please <a href="/Sign-Up">Sign Up</a> for EBB updates to learn when the program will reopen.
            </mat-error>
            <mat-hint *ngIf="address_Zip.value?.length === 10">
              You have reached the maximum number of 10 characters.
            </mat-hint>
        </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 " >
          <div style="display: inline-flex; padding-right: 20px;" class="ng-star-inserted" role="group">
          <mat-form-field appearance="outline">
            <mat-label for="yearBuilt">
              What year was this home built?
            </mat-label>
            <mat-select
              id="yearBuilt"
              name="yearBuilt"
              formControlName="yearBuilt"             
              role="combobox"
              required>
                <mat-option
                  value=""
                  selected
                  disabled>
                    Select Year *
                </mat-option>
                <mat-option
                  *ngFor="let year of yearBuiltArray"
                  [value]="year">
                    {{ year }}
                </mat-option>
            </mat-select>
            <mat-error
            *ngIf="dwellingInput.get('yearBuilt').errors && dwellingInput.get('yearBuilt').errors.required"
            >
            Year built is required.
          </mat-error>
          </mat-form-field>
        </div>
        <div style="display: inline-flex; padding-right: 20px; padding-bottom: 20px;" class="ng-star-inserted">
             <!-- More Information -->
             <button
             mat-button
            
             type="button"
             id="yearbuild-more-info"
             class="more-info"
             attr.aria-label="More Info Year"
             (click)="showMoreYearBuild()">
               MORE INFO
           </button>
          </div>
           <!-- /More Information -->
        </div>

    </div>
    <div class="row" *ngIf="program.typeCode === 700000004">
      <div class="col-md-8">
        <div style="display: inline-flex; padding-right: 20px;" class="ng-star-inserted">
          <mat-form-field appearance="outline" style="flex: 1; min-width: 300px;">
            <mat-label id="squareFootageLabel">What is the square footage of the building?</mat-label>
            <input
            matInput
            id="squareFootage"
            formControlName="squareFootage"
            placeholder="Enter square footage"
            aria-labelledby="squareFootageLabel"
          
            autocomplete="off"
            type="number"
            trim="blur"
            min="1"
            max="1000000"
          />
         
            <mat-error
              *ngIf="dwellingInput.get('squareFootage').errors && dwellingInput.get('squareFootage').errors.required">
              Square footage is required.
            </mat-error>
            <mat-error *ngIf="dwellingInput.get('squareFootage').hasError('max')">
              Square footage cannot exceed 1,000,000.
            </mat-error>
            <mat-error *ngIf="dwellingInput.get('squareFootage').hasError('min')">
              Square footage cannot be less than 1.
            </mat-error>
          </mat-form-field>
          </div>
          <div style="display: inline-flex; padding-right: 20px; padding-bottom: 20px;" class="ng-star-inserted">
            <button
              mat-button
              type="button"
              id="squareFootage-more-info"
              class="more-info"
              attr.aria-label="More Info Units"
              (click)="showMoreSquareFootage()"
              
            >
              MORE INFO
            </button></div>
      
    </div>
    </div>


    <div class="row" *ngIf="program.typeCode === 700000004">
      <div class="col-md-8">
        <div style="display: inline-flex; padding-right: 20px;" class="ng-star-inserted">
          <mat-form-field appearance="outline" style="flex: 1; min-width: 300px;">
            <mat-label id="ownerAssociationLabel">Property Owner/Owner Association</mat-label>
            <input
              matInput
              id="ownerAssociation"
              formControlName="ownerAssociation"
              placeholder="Enter Property Owner/Owner Association"
              type="text"
              trim="blur"
              maxlength="100"
              autocomplete="organization"
              aria-labelledby="ownerAssociationLabel"
             
            />
            <mat-error
              *ngIf="dwellingInput.get('ownerAssociation').errors && dwellingInput.get('ownerAssociation').errors.required">
              Property Owner/Owner Association is required.
            </mat-error>
          </mat-form-field>
          </div>
          <div style="display: inline-flex; padding-right: 20px; padding-bottom: 20px;" class="ng-star-inserted">
            <button
              mat-button
              type="button"
              id="ownerAssociation-more-info"
              class="more-info"
              attr.aria-label="More Info Units"
              (click)="showMoreOwnerAssociation()"
              
            >
              MORE INFO
            </button></div>
      
    </div>
    </div>
    
    <div class="row"  *ngIf="program.typeCode === 700000004">
      <div class="col-md-6 " >
        <div style="display: inline-flex; padding-right: 20px;" class="ng-star-inserted">
        <mat-form-field appearance="outline">
          <mat-label >
            Number of Units
          </mat-label>
          <mat-select
            id="numberOfUnits"
            name="numberOfUnits"
            formControlName="numberOfUnits" 
          
            >
              <mat-option
                value=""
                selected
                disabled>
                  Select Units *
              </mat-option>
              <mat-option
                *ngFor="let unit of numberOfUnitsArray"
                [value]="unit">
                  {{ unit }}
              </mat-option>
          </mat-select>
          <mat-error
          *ngIf="dwellingInput.get('numberOfUnits').errors && dwellingInput.get('numberOfUnits').errors.required"
          >
          Number of Units is required.
        </mat-error>
        </mat-form-field>
      
      </div>
      <div style="display: inline-flex; padding-right: 20px; padding-bottom: 20px;" class="ng-star-inserted">
        <!-- More Information -->
        <button
        mat-button
       
        type="button"
        id="numberOfUnits-more-info"
        class="more-info"
        attr.aria-label="More Info Units"
        (click)="showMoreNubmerOfUnits()">
          MORE INFO
      </button>
     </div>
    </div>
      
         <!-- /More Information -->
     

  </div>

      <div class="row" *ngIf="program.typeCode !== 700000004">
        <div class="col-md-6">
          Is this home your primary residence?
          <br/><br/>
          <mat-button-toggle-group aria-label="Is this home your primary residence?"
            formControlName="homeownerOccupied"
            id="homeownerOccupied">
            <mat-button-toggle [value]="true" id="homeownerOccupiedYes">
              YES
            </mat-button-toggle>
            <mat-button-toggle [value]="false" id="homeownerOccupiedNo">
              NO
            </mat-button-toggle>
          </mat-button-toggle-group>
          <div class="mat-subscript-wrapper">
            <mat-error
              *ngIf="dwellingInput.get('homeownerOccupied')?.touched && 
                dwellingInput.get('homeownerOccupied')?.errors && 
                this.program.homeownerOccupied"
              >
              To qualify for the EBB program the house must be the owner occupied. 
              If you have any questions, please contact us at (877) 232-4300 or <a href="mailto:info@crmp.org">info@crmp.org</a>.
            </mat-error>
          </div>
          <br /><br />
        </div>
      </div>
      <div class="row" *ngIf="dwellingInput.get('pi')">
        <div class="col-md-6">
          <mat-form-field appearance="outline">
            <mat-label id="pilabel">
              Home Insurance Provider
            </mat-label>
            <mat-select
              id="pi"
              name="pi"
              aria-labelledby="pilabel"
              formControlName="pi"
              required>
              <mat-option
                value=""
                selected
                disabled>
                  Select Provider *
              </mat-option>
              <mat-option
                *ngFor="let provider of _policies"
                [value]="provider.value">
                  {{ provider.label }}
              </mat-option>
            </mat-select>
            <mat-error>
              Home Insurance Provider is required.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          
          <!-- Submit for CEA BB -->
          <button
            *ngIf="this._policies"
            class="continue float-right"
            color="primary"
            type="submit"
            id="continue-button-ceabb"
            aria-label="Continue for CEA BB"
            [disabled]="!continueEnabled()"
            mat-raised-button
            aria-disabled="{{!continueEnabled()}}">
            <div style="display: flex; align-items: center;">
              <span>CONTINUE</span>
              <mat-spinner *ngIf="_dwellingNextInProcess" diameter="20" class="spinner" aria-label="Loading"></mat-spinner>
            </div>
          </button>
      
          <!-- Submit for FEMA|EBB -->
          <button
            *ngIf="!this._policies"
            class="continue float-right"
            color="primary"
            type="submit"
            id="continue-button-non-ceabb"
            aria-label="Continue for FEMA or EBB"
            [disabled]="!continueEnabled()"
            mat-raised-button
            aria-disabled="{{!continueEnabled()}}">
            <div style="display: flex; align-items: center;">
              <span>CONTINUE</span>
              <mat-spinner *ngIf="_dwellingNextInProcess" diameter="20" class="spinner" aria-label="Loading"></mat-spinner>
            </div>
          </button>
      
        </div>
      </div>
      
     
    </form>
  </div>
</div>

</section>
</mat-drawer-content>
</mat-drawer-container>
